import { Product } from '@/hooks/use-jurisdiction';

const PRODUCT_ROUTES = {
    [Product.Pickem]: { root: 'PickemHome', tab: 'Lobby', screen: 'LobbyScreen' },
    [Product.Sweeps]: { root: 'SweepsHome', tab: 'SweepsLobby', screen: 'SweepsLobbyScreen' },
    [Product.Arcade]: { root: 'ArcadeHome', tab: 'ArcadeLobby', screen: 'ArcadeLobbyScreen' },
    [Product.Casino]: { root: 'CasinoHome', tab: 'CasinoLobby', screen: 'CasinoLobbyScreen' },
    [Product.Prediction]: { root: 'PredictionHome', tab: 'PredictionLobby', screen: 'PredictionLobbyScreen' },
    [Product.Rips]: { root: 'RipsHome', tab: 'RipsLobby', screen: 'RipsLobbyScreen' },
} as const;

const hasProductRoutes = (product?: Product): product is keyof typeof PRODUCT_ROUTES =>
    !!product && product in PRODUCT_ROUTES;

const getProductRoutes = (product?: Product) => {
    // sportsbook, none and undefined have no root
    if (!hasProductRoutes(product)) {
        return PRODUCT_ROUTES[Product.Pickem];
    }

    return PRODUCT_ROUTES[product];
};

export const getProductRoot = (product?: Product) => getProductRoutes(product).root;

export const getProductLobby = (product?: Product) => {
    const { tab, screen } = getProductRoutes(product);
    return { tab, screen };
};
